import { Reducer } from 'redux';
import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_RESPONSE,
  USER_LOGIN_ERROR,
  USER_LOGIN_RETAILERS_RESPONSE} from '../actions/userLoginAction/userLoginAction';
import { IUserLogin } from '../types';

const initialState: IUserLogin = {
  loading: false,
  error: '',
  userDetails: {
    userId: -1,
  },
  authenticationResponse: {
    retailerToken: null,
    userDetails: {
      userId: -1,
    },
    userRetailers: [],
  },
};

const userLoginReducer: Reducer<IUserLogin> = (state: IUserLogin = initialState, action : any) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST: {
      return {
        ...state,
        error: '',
        loading: true,
      } as IUserLogin;
    }
    case USER_LOGIN_RESPONSE: {
      return {
        ...initialState,
        userDetails: action.response,
      } as IUserLogin;
    }
    case USER_LOGIN_RETAILERS_RESPONSE: {
      return {
        ...initialState,
        authenticationResponse: action.response,
      } as IUserLogin;
    }
    case USER_LOGIN_ERROR: {
      return {
        ...state,
        error: action.error || 'Unable to retrieve user details. Please try again.',
        loading: false,
      } as IUserLogin;
    }
    default: {
      return state;
    }
  }
};

export default userLoginReducer;
